import { useAppLanguageSelector } from '@gov-nx/core/hooks';
import { useConfiguration } from '@gov-nx/core/service';
import { useAxiosCmsInstance } from '../axios/instance';
import { usePoQuery } from '../hooks/usePoQuery';
import type { CmsFaqCategoriesQueryResponse } from './types';

export const useCmsFaqCategoriesQuery = () => {
	const { cmsKeyCache } = useConfiguration();
	const { language } = useAppLanguageSelector();
	const { axiosCmsInstance } = useAxiosCmsInstance();

	const query = usePoQuery({
		queryKey: ['cms-faqs', language],
		queryFn: async () => {
			const response =
				await axiosCmsInstance.get<CmsFaqCategoriesQueryResponse>(
					`/faq-categories/${language}.json?v=${cmsKeyCache}`
				);
			return response.data.data;
		},
		retry: 0,
		refetchOnWindowFocus: false,
	});

	const sortedBySlug = query.data?.sort((a, b) => {
		if (a.slug && b.slug) {
			if (a.slug.split('-')[2] < b.slug.split('-')[2]) return -1;
			if (a.slug.split('-')[2] > b.slug.split('-')[2]) return 1;
		}
		return 0;
	});

	return {
		data: sortedBySlug ?? [],
		isLoading: query.isLoading,
	};
};
